function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ToggleButton from '../button/ToggleButton';
import Icon from '../icon/Icon';
import Divider from '../divider/Divider';
import { isSmallDown } from '../utils/mediaQueries';
import { HAS_WINDOW } from '../utils/dom';
import { STYLE_NONE } from '../button/constants';
import { STYLES_PROP_TYPE, STYLE_CONTAINER, STYLE_PROTOTYPE, STYLE_CONTAINER_DIVIDER, STYLE_ORDER_SUMMARY, VERTICAL_MARGIN_TYPES, VERTICAL_MARGIN_BOTH, VERTICAL_MARGIN_TOP, VERTICAL_MARGIN_BOTTOM } from './constants';
import ChevronUpChunkySvg from '../iconography/icons/ChevronUpChunky';
import ChevronDownChunkySvg from '../iconography/icons/ChevronDownChunky';

var LinkText = function LinkText(_ref) {
  var text = _ref.text,
      isExpanded = _ref.isExpanded,
      linkClassNames = _ref.linkClassNames,
      linkTextClassNames = _ref.linkTextClassNames;
  var iconType = isExpanded ? React.createElement(ChevronUpChunkySvg, null) : React.createElement(ChevronDownChunkySvg, null);
  return React.createElement("div", {
    className: linkClassNames
  }, React.createElement("div", {
    className: linkTextClassNames
  }, text), React.createElement(Icon, {
    type: iconType,
    size: "small"
  }));
};

var ContentDivider = function ContentDivider(_ref2) {
  var hasDivider = _ref2.hasDivider;
  var component = null;

  if (hasDivider) {
    component = React.createElement(Divider, null);
  }

  return component;
};

var ExpansionPanel =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ExpansionPanel, _React$PureComponent);

  function ExpansionPanel(props) {
    var _this;

    _classCallCheck(this, ExpansionPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExpansionPanel).call(this, props));
    var isExpanded = props.isExpanded === undefined ? props.defaultIsExpanded : props.isExpanded;
    _this.state = {
      isExpanded: isExpanded
    };
    return _this;
  }

  _createClass(ExpansionPanel, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref3) {
      var isExpanded = _ref3.isExpanded;

      // We explicitly test for undefined for the case when isExpanded is
      // specifically not passed
      if (isExpanded !== undefined) {
        this.setState({
          isExpanded: isExpanded
        });
      }
    }
  }, {
    key: "_handleClick",
    value: function _handleClick() {
      var _this2 = this;

      var onToggle = this.props.onToggle;
      this.setState(function (_ref4) {
        var prevIsExpanded = _ref4.isExpanded;
        return {
          isExpanded: !prevIsExpanded
        };
      }, function () {
        if (onToggle) {
          onToggle(_this2.state.isExpanded);
        }
      });
    }
  }, {
    key: "_isMobile",
    value: function _isMobile() {
      var isMobile = this.props.isMobile;
      return isMobile || HAS_WINDOW && isSmallDown();
    }
  }, {
    key: "_getStyle",
    value: function _getStyle() {
      var style = this.props.style; // for small screens the container style is used unless container-divider is passed in as style prop

      if (style !== STYLE_ORDER_SUMMARY && style !== STYLE_CONTAINER_DIVIDER && this._isMobile()) {
        return STYLE_CONTAINER;
      }

      return style;
    }
  }, {
    key: "_getLinkTextClassNames",
    value: function _getLinkTextClassNames() {
      var _this$props = this.props,
          style = _this$props.style,
          hasLinkMargin = _this$props.hasLinkMargin;
      return classNames('eds-expansion-panel__link-text', {
        'eds-l-mar-left-4': hasLinkMargin && style !== STYLE_PROTOTYPE
      });
    }
  }, {
    key: "_getClassNames",
    value: function _getClassNames() {
      var style = this._getStyle();

      return classNames('eds-expansion-panel', _defineProperty({}, "eds-expansion-panel--".concat(style), style !== STYLE_PROTOTYPE));
    }
  }, {
    key: "_getLinkClassNames",
    value: function _getLinkClassNames() {
      var style = this._getStyle();

      var verticalMargin = this.props.verticalMargin;
      return classNames('eds-expansion-panel__link', _defineProperty({
        'eds-l-mar-vert-4': style !== STYLE_PROTOTYPE && style !== STYLE_ORDER_SUMMARY && verticalMargin === VERTICAL_MARGIN_BOTH,
        'eds-l-mar-top-4': verticalMargin === VERTICAL_MARGIN_TOP,
        'eds-l-mar-bottom-4': verticalMargin === VERTICAL_MARGIN_BOTTOM,
        'eds-l-mar-vert-2': style === STYLE_ORDER_SUMMARY
      }, "eds-expansion-panel__link--".concat(style), style !== STYLE_PROTOTYPE));
    }
  }, {
    key: "_getContentClassNames",
    value: function _getContentClassNames() {
      var isExpanded = this.state.isExpanded;
      return classNames('eds-expansion-panel__content', {
        'eds-hide': !isExpanded
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          linkText = _this$props2.linkText,
          style = _this$props2.style,
          altLinkText = _this$props2.altLinkText,
          suffix = _this$props2.suffix;
      var isExpanded = this.state.isExpanded;

      var expansionPanelClassNames = this._getClassNames();

      var contentClassNames = this._getContentClassNames();

      var linkTextClassNames = this._getLinkTextClassNames();

      var linkClassNames = this._getLinkClassNames();

      var hasDivider = style === STYLE_CONTAINER_DIVIDER;
      var suffixContainer;
      var toggleChildren = React.createElement(LinkText, {
        text: linkText,
        isExpanded: isExpanded,
        linkTextClassNames: linkTextClassNames,
        linkClassNames: linkClassNames
      });
      var toggleChildrenAlt = React.createElement(LinkText, {
        text: altLinkText || linkText,
        isExpanded: isExpanded,
        linkTextClassNames: linkTextClassNames,
        linkClassNames: linkClassNames
      });

      if (suffix) {
        var suffixClasses = classNames('eds-g-cell', 'eds-g-cell-6-12', 'eds-text--right', 'eds-l-mar-vert-2');
        suffixContainer = React.createElement("div", {
          className: suffixClasses,
          role: "gridcell"
        }, React.createElement("span", {
          className: "eds-text-bm--fixed"
        }, suffix));
      }

      return React.createElement("div", null, React.createElement("div", {
        className: expansionPanelClassNames,
        "data-spec": "expansion-panel-button-wrapper"
      }, React.createElement(ToggleButton, {
        childrenAlt: toggleChildrenAlt,
        onPress: this._handleClick.bind(this),
        style: STYLE_NONE,
        isPressed: isExpanded
      }, toggleChildren)), suffixContainer, React.createElement(ContentDivider, {
        hasDivider: hasDivider
      }), React.createElement("div", {
        className: contentClassNames,
        "data-spec": "expansion-panel-content"
      }, children));
    }
  }]);

  return ExpansionPanel;
}(React.PureComponent);

_defineProperty(ExpansionPanel, "propTypes", {
  /**
  * The content to be expanded or collapsed
  **/
  children: PropTypes.node.isRequired,

  /**
  * The display text of the link
  **/
  linkText: PropTypes.node.isRequired,

  /**
  * The alternate display text of the link (optional)
  **/
  altLinkText: PropTypes.node,

  /**
   * Whether or not the component should be expanded by default
   **/
  defaultIsExpanded: PropTypes.bool,

  /**
  * Whether or not the component should be expanded, overriding any existing state
  **/
  isExpanded: PropTypes.bool,

  /**
   * Callback that is called when the toggle occurs
   **/
  onToggle: PropTypes.func,

  /**
  * user agent is mobile
  **/
  isMobile: PropTypes.bool,

  /**
   * The value displayed on the right side of the expansion panel
   * i.e. $14.00
   */
  suffix: PropTypes.node,

  /**
  * Style variant for component
  * Available styles: default, container, container-divider, order-summary
  **/
  style: STYLES_PROP_TYPE,

  /**
  * Has 16px left margin for linktext when style is container or container-divider
  **/
  hasLinkMargin: PropTypes.bool,

  /**
  * Type of vertical margin for the link container
  * Options are 'top', 'bottom' and 'both' for vertical margin. Adds 4 grid units of margin
  **/
  verticalMargin: VERTICAL_MARGIN_TYPES
});

_defineProperty(ExpansionPanel, "defaultProps", {
  defaultIsExpanded: false,
  isMobile: false,
  style: STYLE_PROTOTYPE,
  hasLinkMargin: false,
  verticalMargin: VERTICAL_MARGIN_BOTH
});

export { ExpansionPanel as default };